import type { OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Datastore } from '@freelancer/datastore';
import type { SiteStatsCollection } from '@freelancer/datastore/collections';
import { Seo } from '@freelancer/seo';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  template: ` <app-home-page></app-home-page> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageMetaWrapperComponent implements OnInit, OnDestroy {
  private datastore = inject(Datastore);
  private seo = inject(Seo);
  private subscriptions = new Subscription();

  ngOnInit(): void {
    this.subscriptions.add(
      this.datastore
        .document<SiteStatsCollection>('siteStats')
        .valueChanges()
        .pipe(
          map(stat => ({
            projectCountInMillions: `${
              Math.floor(stat.projectCount / 100_000) / 10
            }+`,
            skillCount: `${Math.floor(stat.categoryCount / 100) * 100}+`,
          })),
        )
        .subscribe(({ projectCountInMillions, skillCount }) => {
          this.seo.setPageTags({
            title: $localize`:Meta title:Hire Freelancers & Find Freelance Jobs Online`,
            description: $localize`:Meta description:Access the world's largest cloud workforce. ${projectCountInMillions}:projectCountInMillions: million jobs completed across ${skillCount}:skillCount: skills. Post your job free, compare quotes, and hire top talent today.`,
          });
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
